import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {hex2rgba, spacing} from '@yandex-delivery/blocks/theme/theme'

export const root = css`
  background-color: ${cssTheme.default.day.backgroundMinor};
  block-size: ${spacing(13.5)};
  min-block-size: ${spacing(12.25)};
  min-inline-size: ${spacing(19.75)};
  border-radius: ${spacing(2)};
  cursor: pointer;
  padding: ${spacing(1.5)};
  position: relative;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${cssTheme.components.buttons.default.bgColorHovered};
  }

  &:active {
    background-color: ${cssTheme.components.buttons.default.bgColorPressed};
  }
`
export const radio = css`
  ${cssTheme.default.day.controlMinor.token}: ${hex2rgba(cssTheme.default.day.text.hex, 0)};
`
export const image = css`
  object-fit: contain;
  block-size: auto;
  max-inline-size: 100%;
`
export const last = css`
  margin-top: auto;
`
export const badge = css`
  inset-block-start: ${spacing(-0.5)}; // -4px
  inset-inline-end: ${spacing(-0.5)}; // -4px
  position: absolute;
`

export const badgeNew = css`
  background-color: ${cssTheme.colors.cinnabar.toxic};
  box-shadow: 0 2px 5px 0 ${hex2rgba(cssTheme.colors.cinnabar.toxic.hex, 0.3)};
  opacity: 100%;
  display: inline;
  width: fit-content;
  padding: ${spacing(0.125, 0.5)};
  margin-inline-start: ${spacing(0.5)};
`
